import React, { useContext, useEffect } from "react";
import Form from "../../Helpers/Form/Form";
import { popupcontext } from "../../../context/Popupscontext";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../Helpers/Form/FormParts/FormHeader";
import trans from "../../../utils";
import CustomerBody from "./CustomerBody";
import { useGetSingleCustomerQuery } from "../../../Redux/service/Customer/Customer";

export default function CustomerForm({ onSuccess }) {
	const { form, isEditing, currentCustomerId } = useContext(popupcontext);
	const { refetch, data: customer } = useGetSingleCustomerQuery(
		currentCustomerId,
		{
			skip: !currentCustomerId,
		}
	);

	return (
		<>
			<Form show={form}>
				<Offcanvas.Header>
					<FormHeader
						title={
							isEditing ? trans("Edit customer") : trans("Add new customer")
						}
					/>
				</Offcanvas.Header>
				<div className="H-line"></div>
				<CustomerBody
					onSuccess={onSuccess}
					Editvalues={customer?.data}
					refetch={refetch}
				/>
			</Form>
		</>
	);
}
